export const servicesData = [
    {
        id: 'consultancy',
        title: 'Consultancy',
        description: 'Expert advice on architectural design, planning, and project management to bring your vision to life.',
        features: ['Site Analysis', 'Design Consultation', 'Project Planning', 'Budget Estimation'],
        iconName: 'Building2',
        longDescription: `Our consultancy services provide comprehensive guidance for your construction and design projects. We help you navigate through every stage of development, ensuring that your vision is realized with precision and efficiency. From initial site analysis to detailed project planning and budget estimation, our experts are here to support you.`
    },
    {
        id: 'furniture-design',
        title: 'Furniture Design',
        description: 'Custom furniture solutions that blend aesthetics with functionality for your unique space.',
        features: ['Custom Designs', 'Material Selection', '3D Visualization', 'Installation Support'],
        iconName: 'Palette',
        longDescription: `We create bespoke furniture pieces that are tailored to your specific needs and style preferences. Our team combines aesthetic appeal with practical functionality to deliver furniture that enhances your living or working space. We handle everything from concept design and material selection to 3D visualization and final installation.`
    },
    {
        id: 'supervising',
        title: 'Supervising',
        description: 'Professional supervision ensuring quality construction and adherence to design specifications.',
        features: ['Quality Control', 'Progress Monitoring', 'Vendor Coordination', 'Issue Resolution'],
        iconName: 'ClipboardCheck',
        longDescription: `Our supervision services ensure that your project is executed to the highest standards of quality and safety. We monitor progress closely, coordinate with vendors, and resolve any issues that arise on-site to ensure strict adherence to design specifications and timelines.`
    },
    {
        id: 'space-planning',
        title: 'Space Planning',
        description: 'Optimize your space with intelligent layouts that maximize functionality and flow.',
        features: ['Layout Design', 'Space Optimization', 'Traffic Flow Analysis', 'Zoning Plans'],
        iconName: 'LayoutGrid',
        longDescription: `Maximize the potential of your interior environments with our expert space planning services. We analyze traffic flow, functionality, and zoning requirements to create intelligent layouts that are both practical and visually appealing.`
    },
    {
        id: 'site-execution',
        title: 'Site Execution',
        description: 'Complete construction services from foundation to finishing with attention to detail.',
        features: ['Construction Management', 'Quality Materials', 'Skilled Workforce', 'Timely Delivery'],
        iconName: 'Hammer',
        longDescription: `From breaking ground to the final coat of paint, our site execution team manages every aspect of construction. We ensure the use of quality materials, deploy a skilled workforce, and maintain strict timelines to deliver your project with exceptional attention to detail.`
    },
    {
        id: 'civil-planning',
        title: 'Civil Planning',
        description: 'Comprehensive civil engineering solutions for residential and commercial projects.',
        features: ['Structural Design', 'MEP Planning', 'Compliance Check', 'Documentation'],
        iconName: 'Ruler',
        longDescription: `Our civil planning services cover all structural and engineering aspects of your project. We provide detailed structural designs, MEP (Mechanical, Electrical, Plumbing) planning, compliance checks, and necessary documentation to ensure a solid foundation for success.`
    }
];
